// src/pages/Main.tsx
import PostList from "../components/post/PostList";

const Main = () => {
  return (
    <div>
      <PostList />
    </div>
  );
};

export default Main;
